export default function getBevName(link) {
  return link && link.eid;
}